import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { getPassportDomainHost } from '@/src/utils/host';
import { requestDataAnalysis } from './request';

const SLDataAnalysis = Mach.requireModule('SLDataAnalysis');

const EventCenter = Mach.requireModule('EventCenter');

// Raptor 上报
const reportRaptor = (idx) => {
  reportRaptorMetrics({ data_na_ut: (idx > 0) ? 1 : 0 }, {
    idx
  });
};

// Raptor 上报
const request = async (token, tokenID, joinkey, idx) => {
  // -1(未知，仅Android存在)，0(都未安装)，其它 安装
  let tourist = '1'; // 有
  if (idx == -1) {
    tourist = '3'; // 未知
  } else if (idx == 0) {
    tourist = '2'; // 没有
  }
  const domain = getPassportDomainHost();
  const url = `${domain}/api/changeuserinfo/v1/changeExt`;

  let package_name = 'com.sankuai.sailor.afooddelivery';
  if (Mach.env.isIOS) {
    const appBundle = SLDataAnalysis.appBundleId();
    package_name = appBundle?.bundle_id || 'com.sankuai.sailor.ifooddelivery';
  }
  // 网络请求
  const [error] = await requestDataAnalysis({
    url,
    params: {
      token,
      token_id: tokenID,
      joinkey,
      package_name
    },
    header: {
      token,
    },
    data: {
      '2:tourist': tourist,
    },
  });

  console.log('====================================');
  console.log('error:', error);
  console.log('====================================');

  const value = (!error) ? 1 : 0;
  reportRaptorMetrics({ data_na_ut_result: value }, {
    idx,
    errorCode: String(error?.code) || '0',
    errorMsg: error?.message || '',
    errorType: String(error?.type) || '',
  });
};

const dataAnalysis = (token, tokenID, joinkey, idx) => {
  // 网络请求
  request(token, tokenID, joinkey, idx);

  // Raptor 上报
  reportRaptor(idx);
};

export const startDataAnalysis = () => {
  console.log('startDataAnalysis start');
  if (!SLDataAnalysis) {
    console.log('SLDataAnalysis undfine');
    return;
  }

  // 登录状态变化
  const Login = Mach.requireModule('Login');
  const eventOfLogin = Login?.eventOfLogin();
  // 登陆
  EventCenter.addListener(eventOfLogin, () => {
    const userInfo = SLDataAnalysis?.getInfo();
    console.log('====================================');
    console.log('userInfo:', userInfo);
    console.log('====================================');
    if (!userInfo) {
      return;
    }
    const token = userInfo?.token;
    const token_id = userInfo?.token_id;
    const joinkey = userInfo?.joinKey;
    if (!token || !token_id) {
      return;
    }
    const dataInfo = SLDataAnalysis.tiType();
    const { idx } = dataInfo;
    // 数据分析
    dataAnalysis(token, token_id, joinkey, idx);
  });
  console.log('startDataAnalysis end');
};
